import React, { Component } from 'react';

import 'react-infinite-calendar/styles.css';
import CalendarNavBar from '../../nav/CalendarNavBar';
import Designer from './Designer';

import Console from '../../../lib/debug';

import * as LibraryState from '../../../state/reducer/library/library';
import * as NavState from '../../../state/reducer/nav/nav';

class DesignerView extends Component {
    constructor(props) {
        super(props);
        this.loadExerciseLibrary();
    }
    componentWillMount() {
        NavState.enableDesignerHeader();
    }
    componentDidUpdate() {
        this.loadExerciseLibrary();
    }
    componentWillUnmount() {
        NavState.disableDesignerHeader();
    }
    loadExerciseLibrary() {
        LibraryState.loadExercises();
        LibraryState.loadSchemes();
        LibraryState.loadParamTypes();
        LibraryState.loadLeaderboardTypes();
    }
    render() {
        Console.render('DesignerView');
        return (
            <div>
                <CalendarNavBar />
                <Designer />
            </div>
        );
    }
}

export default DesignerView;
